<section id="filterContainer" class="w-full rounded-xl p-8 bg-primary-purple-light-2">
  <h1 class="title text-lg">{{ literalService.get('filters', true) }}</h1>
  <article class="mt-6 flex flex-wrap gap-6">
    @for (column of columns(); track column.field) {
      <div class="flex flex-col items-start gap-4" [class.w-48]="definitions[column.field].kind !== FilterFieldKind.CHECKBOX_GROUP">
        <span class="title-columns">{{ column.label }}</span>
        @for (field of column.fields; track field) {
        @switch (definitions[field].kind) {
          @case (FilterFieldKind.MULTISELECT) {
            @switch (field) {
              @case (FilterField.CLIENTS) {
                <article class="flex h-10 w-full items-center">
                  <app-multi-select-form
                    [title]="'filter-clients'"
                    [elements]="clients"
                    [values]="selectedClients"
                    [width]="'48'"
                    [placeholder]="literalService.get('all', true)"
                    [orderById]="false"
                    (closeEventEmitter)="onClientsClose()"
                  />
                </article>
              }
              @case (FilterField.AREAS) {
                <article class="flex h-10 w-full items-center">
                  <app-multi-select-form
                    [title]="'filter-areas'"
                    [elements]="areas"
                    [values]="selectedAreas"
                    [width]="'48'"
                    [placeholder]="literalService.get('allAreas', true)"
                    [orderById]="false"
                    (closeEventEmitter)="onAreasClose()"
                  />
                </article>
              }
              @case (FilterField.OPERATORS) {
                <article class="flex h-10 w-full items-center">
                  <app-multi-select-form
                    [title]="'filter-operators'"
                    [elements]="operators"
                    [values]="selectedOperators"
                    [width]="'48'"
                    [placeholder]="literalService.get('all', true)"
                    [orderById]="false"
                  />
                </article>
              }
              @case (FilterField.SENDERS) {
                <article class="flex h-10 w-full items-center">
                  <app-multi-select-form
                    [title]="'filter-senders'"
                    [elements]="senders"
                    [values]="selectedSenders"
                    [width]="'48'"
                    [placeholder]="literalService.get('all', true)"
                    [orderById]="false"
                  />
                </article>
              }
            }
          }

          @case (FilterFieldKind.RECEIVERS) {
            <app-filter-receivers
              class="flex w-full flex-col gap-2"
              [communicationUserType]="communicationUserType()"
              [towns]="areas"
              [selection]="receiversSelection"
            />
          }

          @case (FilterFieldKind.AREAS_SERVICES) {
            @if (!definitions[field].hidesAreas) {
              <article class="flex h-10 w-full items-center">
                <app-multi-select-form
                  [title]="'filter-areas'"
                  [elements]="areas"
                  [values]="selectedAreas"
                  [width]="'48'"
                  [placeholder]="literalService.get('allAreas', true)"
                  (closeEventEmitter)="onAreasClose()"
                />
              </article>
            }
            <article class="flex w-full items-center">
              <app-input
                class="w-full"
                [data]="{ id: 'filter-services', value: lists['SERVICES']?.values, edit: { editable: true, inputType: InputType.MULTISELECT_SCROLL, values: lists['SERVICES']?.options, customSearchEnabled: true, placeholder: literalService.get('all', true) } }"
                [edit]="true"
                [independent]="true"
                (setEventEmitter)="onSelectionChange('SERVICES', $event.value)"
                (scrollEventEmitter)="onScroll($event, 'SERVICES')"
                (searchEventEmitter)="onSearch($event, 'SERVICES')"
              />
            </article>
            @if (field === FilterField.AREAS_SERVICES_EXPEDITIONS) {
              <article
                class="flex w-full items-center"
                [tooltip]="lists['EXPEDITIONS']?.disabled ? literalService.get('suggestions.tooltips.expeditionFilterRequiresService', true) : ''"
                [position]="TooltipPosition.BELOW"
              >
                <app-input
                  class="w-full"
                  [data]="{ id: 'filter-expeditions', value: lists['EXPEDITIONS']?.values, edit: { editable: true, inputType: InputType.MULTISELECT_SCROLL, values: lists['EXPEDITIONS']?.options, customSearchEnabled: true, disabled: lists['EXPEDITIONS']?.disabled, placeholder: literalService.get('all', true) } }"
                  [edit]="true"
                  [independent]="true"
                  (setEventEmitter)="onSelectionChange('EXPEDITIONS', $event.value)"
                  (scrollEventEmitter)="onScroll($event, 'EXPEDITIONS')"
                  (searchEventEmitter)="onSearch($event, 'EXPEDITIONS')"
                />
              </article>
            }
            @if (definitions[field].showsRoutes) {
              <article class="flex w-full items-center">
                <app-input
                  class="w-full"
                  [data]="{ id: 'filter-routes', value: lists['ROUTES']?.values, edit: { editable: true, inputType: InputType.MULTISELECT_SCROLL, values: lists['ROUTES']?.options, customSearchEnabled: true, disabled: lists['ROUTES']?.disabled, placeholder: literalService.get('all', true) } }"
                  [edit]="true"
                  [independent]="true"
                  (setEventEmitter)="onSelectionChange('ROUTES', $event.value)"
                  (scrollEventEmitter)="onScroll($event, 'ROUTES')"
                  (searchEventEmitter)="onSearch($event, 'ROUTES')"
                />
              </article>
            }
          }

          @case (FilterFieldKind.OPTION_MULTISELECT) {
            <article class="flex h-10 w-full items-center">
              <label class="sr-only" [for]="'dataText-filter-' + field">
                {{ literalService.get(definitions[field].label, true) }}
              </label>
              <app-multi-select-form
                [title]="'filter-' + field"
                [elements]="optionElements()[field]!"
                [values]="optionSelections()[field]"
                [width]="'48'"
                [placeholder]="literalService.get('all', true)"
                [orderById]="false"
                [showSearch]="false"
                [emitOnChange]="true"
                (changeEventEmitter)="onOptionsChange(field)"
              />
            </article>
          }

          @case (FilterFieldKind.MULTISELECT_SCROLL) {
            <article class="flex w-full items-center">
              <app-input
                class="w-full"
                [data]="{ id: 'filter-' + field, value: lists[field]?.values, edit: { editable: true, inputType: InputType.MULTISELECT_SCROLL, values: lists[field]?.options, customSearchEnabled: true, placeholder: literalService.get('all', true) } }"
                [edit]="true"
                [independent]="true"
                (setEventEmitter)="onSelectionChange(field, $event.value)"
                (scrollEventEmitter)="onScroll($event, field)"
                (searchEventEmitter)="onSearch($event, field)"
              />
            </article>
          }

          @case (FilterFieldKind.STATUS_GROUP) {
            <article class="flex w-full flex-col gap-2">
              @for (group of statusGroups(); track group) {
                <label class="flex cursor-pointer items-center gap-2 text-sm font-medium">
                  <input
                    type="radio"
                    name="filter-status-group"
                    class="shrink-0 cursor-pointer radio radio-xs"
                    [checked]="selectedStatusGroup === group"
                    (change)="onStatusGroupChange(group)"
                  />
                  <span class="truncate">{{ literalService.get(group.toLowerCase(), true) }}</span>
                </label>
                @if (selectedStatusGroup === group && groupStatuses(group).length) {
                  <article class="ml-5 flex flex-col gap-2">
                    @for (status of groupStatuses(group); track status) {
                      <label class="flex cursor-pointer items-center gap-2 text-sm font-medium">
                        <input
                          [type]="allowsManyStatuses(group) ? 'checkbox' : 'radio'"
                          name="filter-status"
                          class="shrink-0 cursor-pointer"
                          [ngClass]="allowsManyStatuses(group) ? '' : 'radio radio-xs'"
                          [checked]="isStatusChecked(status)"
                          (change)="onStatusChange(group, status)"
                        />
                        <span class="truncate">{{ literalService.get(status.toLowerCase(), true) }}</span>
                      </label>
                    }
                  </article>
                }
              }
            </article>
          }

          @case (FilterFieldKind.CHECKBOX_GROUP) {
            <article class="flex w-full flex-col gap-2">
              @for (option of checkboxes[field]; track option.value) {
                <app-checkbox
                  [id]="field + '-' + option.value"
                  [text]="optionLabel(field, option.value)"
                  [value]="option"
                  [checked]="option.checked"
                  [icon]="optionIcon(field, option.value)"
                  [tooltipText]="optionTooltip(field, option.value)"
                  [alwaysShowTooltip]="optionTooltip(field, option.value) !== ''"
                  (onChange)="onCheckboxChange(field, option.value)"
                />
              }
            </article>
          }

          @case (FilterFieldKind.ORIGIN_DESTINATION) {
            <article class="box flex h-10 w-full items-center rounded bg-white px-4">
              <img src="assets/images/origin.svg" alt="origin" class="mr-2 h-4 w-4" />
              <input class="w-full focus:outline-none" [(ngModel)]="origin" [name]="'filter-origin'" />
            </article>
            <article class="box flex h-10 w-full items-center rounded bg-white px-4">
              <img src="assets/images/destination.svg" alt="destination" class="mr-2 h-4 w-4" />
              <input class="w-full focus:outline-none" [(ngModel)]="destination" [name]="'filter-destination'" />
            </article>
          }

          @case (FilterFieldKind.DATE_RANGE) {
            <article class="flex h-10 w-full items-center">
              <app-calendar
                [id]="'filter-from'"
                [title]="'filter-from'"
                [value]="fromDateText()"
                [allDays]="!pastDatesOnly()"
                [maxDate]="pastDateLimit(to)"
                (change)="changeDate($event, 'from')"
              />
            </article>
            <article class="flex h-10 w-full items-center">
              <app-calendar
                [id]="'filter-to'"
                [title]="'filter-to'"
                [value]="toDateText()"
                [onlyFutureDays]="!pastDatesOnly()"
                [minDate]="fromDateLimit()"
                [maxDate]="pastDateLimit()"
                (change)="changeDate($event, 'to')"
              />
            </article>
          }

          @case (FilterFieldKind.TIME_RANGE) {
            <article class="flex h-10 w-full items-center">
              <input
                id="filter-start-time"
                type="time"
                class="box h-10 w-full rounded bg-white px-4 focus:outline-none"
                [value]="startTime"
                autocomplete="one-time-code"
                (change)="changeTime($event, 'start')"
              />
            </article>
            <article class="flex h-10 w-full items-center">
              <input
                id="filter-end-time"
                type="time"
                class="box h-10 w-full rounded bg-white px-4 focus:outline-none"
                [value]="endTime"
                autocomplete="one-time-code"
                (change)="changeTime($event, 'end')"
              />
            </article>
          }
        }
        }
      </div>
    }
  </article>

  <article class="mt-24 flex items-center justify-end gap-4">
    <input
      type="button"
      class="secondary h-10 min-w-36 cursor-pointer font-semibold uppercase border px-4"
      [value]="literalService.get('resetFilters', true)"
      (click)="clearSelection()"
    />
    <input
      type="button"
      class="primary h-10 min-w-36 cursor-pointer font-semibold uppercase px-4"
      [value]="literalService.get('filter', true)"
      (click)="onSubmit()"
    />
  </article>
</section>
